import { Injectable, inject } from '@angular/core';
import { ModalService } from './modal.service';
import { LocalStorageService, LocalStorageKeys } from '@formbird/services';

const currentYear = new Date().getFullYear();

@Injectable()
export class AboutDialogService {
  private modalService = inject(ModalService);
  private localStorageService = inject(LocalStorageService);


  showAboutDialog(): void {

    const appVersion = this.localStorageService.getItem(LocalStorageKeys.APP_VERSION);

    this.modalService.openDialog({
      data: {
        html: `
          <img src="images/formbird-logo-makes-it-possible.png" alt="Formbird Logo" />
          
            
            <p>
              <a href="https://www.formbird.com/" title="Formbird – Formbird makes it possible">
                Formbird.com
              </a> version ${appVersion}
            </p>
            <p>&copy; ${currentYear} Formbird Pty Ltd. All rights reserved.</p>
          `,
        confirmButton: true,
        messageType: 'ft-about-us'
      },
      panelClass: 'ft-about-us-wrap'
    });
  }
}
